const BASE_URL = process.env.REACT_APP_BASE_URL;

const API_ENDPOINTS = {
  inventory: {
    uploadExcel: `${BASE_URL}inventory/upload-excel`,
    getInventory: (pageNo) => `${BASE_URL}inventory/list?page=${pageNo}`, 
    downloadSample: `${BASE_URL}download/inventory-upload-sample`,
    store: `${BASE_URL}inventory/store`,
  },
  warehouse: {
    create: `${BASE_URL}warehouse`,
    getAll: `${BASE_URL}warehouse`,
    update: (id) => `${BASE_URL}warehouse/${id}`,
    delete: (id) => `${BASE_URL}warehouse/${id}`,
  },
  // Add more sections as needed...
};


export default API_ENDPOINTS;